import {
  CLEAR_ACCOUNT,

  DELETE_ACCOUNT,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_SUCCESS,

  GET_ACCOUNT,
  GET_ACCOUNT_ERROR,
  GET_ACCOUNT_SUCCESS,

  GET_ACCOUNTS,
  GET_ACCOUNTS_ERROR,
  GET_ACCOUNTS_SUCCESS,

  SAVE_ACCOUNT,
  SAVE_ACCOUNT_ERROR,
  SAVE_ACCOUNT_SUCCESS,

} from './constants';

export default {
  [CLEAR_ACCOUNT](state) {
    state.account = {
      type: '',
      name: '',
      syndicateID: '',
    };
  },

  [DELETE_ACCOUNT](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_ACCOUNT_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DELETE_ACCOUNT_SUCCESS](state) {
    state.account = false;
    state.loading = false;
    state.success = true;
  },

  [GET_ACCOUNT](state) {
    state.account = false;
    state.error = false;
    state.loading = true;
  },
  [GET_ACCOUNT_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ACCOUNT_SUCCESS](state, payload) {
    state.account = payload;
    state.loading = false;
  },

  [GET_ACCOUNTS](state) {
    state.accounts = {
      assets: [],
      liabilities: [],
      expenses: [],
      incomes: [],
      transfer: [],
    };
    state.error = false;
    state.loading = true;
  },
  [GET_ACCOUNTS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ACCOUNTS_SUCCESS](state, payload) {
    payload.forEach((account) => {
      switch (account.type) {
        case 'ASSET':
          state.accounts.assets.push(account);
          break;
        case 'LIABILITY':
          state.accounts.liabilities.push(account);
          break;
        case 'EXPENSE':
          state.accounts.expenses.push(account);
          break;
        case 'INCOME':
          state.accounts.incomes.push(account);
          break;
        case 'TRANSFER':
          state.accounts.transfer.push(account);
          break;
        default:
      }
    });
    // state.accounts = payload;
    state.loading = false;
  },

  [SAVE_ACCOUNT](state) {
    state.error = false;
    state.formLoading = true;
    state.success = false;
  },
  [SAVE_ACCOUNT_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_ACCOUNT_SUCCESS](state, payload) {
    switch (payload.type) {
      case 'ASSET':
        state.accounts.assets.splice(payload.rowIndex, 1, payload);
        break;
      case 'LIABILITY':
        state.accounts.liabilities.splice(payload.rowIndex, 1, payload);
        break;
      case 'EXPENSE':
        state.accounts.expenses.splice(payload.rowIndex, 1, payload);
        break;
      case 'INCOME':
        state.accounts.incomes.splice(payload.rowIndex, 1, payload);
        break;
      case 'TRANSFER':
        state.accounts.transfer.splice(payload.rowIndex, 1, payload);
        break;
      default:
    }
    state.formLoading = false;
    state.success = true;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.account[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Accounts/mutations.js